import { attempts as attemptsApi, simulations as simulationsApi } from '../../../services/api';
import {
  AttemptDetailsResponse,
  AttemptFiltersState,
  AttemptHistoryResponse,
  AttemptsListResponse,
} from '../types';

export const attemptsService = {
  async listAttempts(filters?: Partial<AttemptFiltersState>): Promise<AttemptsListResponse> {
    const res = await attemptsApi.list(filters as any);
    return ((res as any)?.data || res) as unknown as AttemptsListResponse;
  },

  async getAttemptDetails(attemptId: string): Promise<AttemptDetailsResponse> {
    const res = await attemptsApi.getDetails(attemptId);
    return ((res as any)?.data || res) as unknown as AttemptDetailsResponse;
  },

  async getSimulationAttemptHistory(simulationId: string): Promise<AttemptHistoryResponse> {
    const res = await simulationsApi.getAttemptHistory(simulationId);
    return ((res as any)?.data || res) as unknown as AttemptHistoryResponse;
  },

  async resumeAttempt(attemptId: string): Promise<{ success: boolean; attempt: any }> {
    const res = await attemptsApi.resume(attemptId);
    return res as any;
  },

  async startNewAttempt(simulationId: string, language?: string): Promise<{ success: boolean; attempt: any }> {
    const effectiveLanguage = language || (typeof window !== 'undefined' ? sessionStorage.getItem('trainova_preferred_language') : null) || 'en';
    const res = await simulationsApi.startAttempt(simulationId, { language: effectiveLanguage });
    return res as any;
  },
};
